<!--门店休息设置-->
<template>
  <div class="root-container">
    <el-form
      label-width="120px"
      :rules="rules"
      :model="bookInfo"
      ref="refFormData"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="phoneNumber">
            <el-input
              style="width: 270px"
              placeholder=""
              :readonly="true"
              v-model="bookInfo.phoneNumber"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="月龄:" prop="childMonth">
            <el-input
              style="width: 270px"
              placeholder=""
              :readonly="true"
              v-model="bookInfo.childMonth"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="childName">
            <el-input
              style="width: 270px"
              v-model="bookInfo.childName"
              placeholder=""
              :readonly="true"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select
              v-model="bookInfo.gender"
              placeholder="请选择"
              style="width: 270px"
              disabled
            >
              <el-option
                v-for="item in genderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="上课日期:">
            <el-date-picker
              style="width: 270px"
              @change="changeDay"
              v-model="bookInfo.dayTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本:" prop="lessonId">
            <el-select
              v-model="bookInfo.lessonId"
              placeholder="请选择"
              style="width: 270px"
              @change="changeLessonIdX"
              clearable=""
            >
              <el-option
                v-for="item in [
                  { label: 'A', value: 2 },
                  { label: 'B', value: 1 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务:" prop="yuw_id">
            <el-select
              placeholder="请选择"
              style="width: 270px"
              clearable=""
              v-model="bookInfo.yuw_id"
              @change="changeyuwID"
            >
              <el-option
                v-for="item in yuwList"
                :key="item.storeLessonId"
                :label="item.name"
                :value="item.storeLessonId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择卡:" prop="expCardId">
            <el-select
              style="width: 270px"
              v-model="bookInfo.expCardId"
              placeholder="请选择"
              clearable=""
            >
              <el-option
                v-for="item in cardList"
                :key="item.id"
                :label="item.cardName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="课程:" prop="releaseLessonId">
            <!-- <el-select
              v-model="bookInfo.storeReleaseLessonId"
              placeholder="请选择"
              style="width: 270px"
            >
              <el-option
                v-for="item in storeReleaseLessons"
                :key="item.id"
                :label="praseLessonName(item)"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <el-select
              v-model="bookInfo.releaseLessonId"
              placeholder="请选择"
              style="width: 270px"
            >
              <el-option
                v-for="item in keList"
                :key="item.id"
                :label="praseLessonName(item)"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-form-item label="备注:" prop="remark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          style="width: 665px"
          v-model="bookInfo.remark"
        ></el-input>
      </el-form-item>
      <el-form-item label="语音备注:" prop="recording">
        <div style="width: 665px">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-top: 10px;">
            <audio controls ref="audio" class="aud">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="onClickBookLesson()">保存</el-button>
    </div>
  </div>
</template>
<script>
import timeUtils from "../../utils/timeUtils";
import globaldata from "../../utils/globaldata";
import { qlDayReleaseLessons } from "../../api/StoreReleaseLesson";
import commonUtils from "../../utils/commonUtils";
import enumsUtil from "../../utils/enumsUtil";
import { adminBookLesson, regulerBook } from "@/api/userBookLesson";
import messageUtils from "../../utils/messageUtils";
import { formatDate } from "../../utils/date";
import soundRecording from "@/components/soundRecording";
import {
  qlLessonTemplate,
  queryListUserBuyCardByUserIdGETY,
} from "@/api/StoreLesson";

export default {
  name: "BookLessonForChild",
  props: {
    isVip: Boolean,
    lessonTemplateId: null,
    child: Object,
    vipChild: Object,
    storeLessonExpCards: Array,
  },
  components: {
    soundRecording,
  },
  data() {
    return {
      rules: {
        releaseLessonId: [
          {
            required: true,
            message: "请选择课程",
            trigger: "change",
          },
        ],
      },
      bookInfo: {},
      //是否是固定约课
      isRegular: false,

      queryParam: {
        dayTime: "",
        lessonTemplateId: "",
      },
      //店铺发布的课程
      storeReleaseLessons: [],

      selectWeekDay: "",
      monday: timeUtils.getFirstDayOfWeek(new Date()),
      weekDay: [],

      regularType: 0,
      regularTypeOptions: [
        { value: 0, label: "长期固定" },
        { value: 1, label: "临时固定" },
      ],
      noRegularDay: [],
      noRegularStartDay: "",
      noRegularEndDay: "",

      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],

      yuwList: [],
      cardList: [],
      keList: [],
      audio:''
    };
  },
  created() {
    this.initData();
  },
  methods: {
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    changeyuwID(e) {
      this.$set(this.bookInfo, "expCardId", null);
      this.$set(this.bookInfo, "cardTime", "");
      this.$set(this.bookInfo, "totalPay", "");
      this.$set(this.bookInfo, "classCount", "");
      this.$set(this.bookInfo, "realPay", "");
      this.$set(this.bookInfo, "releaseLessonId", "");
      this.cardList = [];
      if (e) {
        this.selectCardsHttp(e);
        this.qlDayReleaseLessonsHttp(e);
      }else{
        this.qlDayReleaseLessonsHttp();
      }
    },
    nowTimeGET() {
      const now = new Date();
      let day = formatDate(now, 'yyyy-MM-dd')
      return timeUtils.transDayInt(day);
      // const year = now.getFullYear(); // 年
      // const month = now.getMonth() + 1; // 月
      // const date = now.getDate(); // 日
      // console.log(year,month,date,'date')
      // return year.toString() + month.toString() + date.toString();
    },
    async qlDayReleaseLessonsHttp(storeLessonId) {
      let dayTime = this.nowTimeGET();
      const response = await qlDayReleaseLessons({
        // dayTime: dayTime,
        dayTime: this.bookInfo.dayTime ? timeUtils.transDayInt(this.bookInfo.dayTime) : dayTime,
        lessonTemplateId: this.bookInfo.lessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        storeLessonId:storeLessonId ? storeLessonId : null,
      });
      if (response.code === 20000) {
        this.keList = response.data;
      }
    },
    async selectCardsHttp(lessonId) {
      const response = await queryListUserBuyCardByUserIdGETY({
        userId: this.child.userId,
        lessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.cardList = response.data;
      }
    },
    changeLessonIdX(e) {
      this.$set(this.bookInfo, "yuw_id", null);
      this.$set(this.bookInfo, "expCardId", null);
      this.$set(this.bookInfo, "cardTime", "");
      this.$set(this.bookInfo, "totalPay", "");
      this.$set(this.bookInfo, "classCount", "");
      this.$set(this.bookInfo, "realPay", "");
      this.$set(this.bookInfo, "releaseLessonId", "");
      this.yuwList = [];
      this.cardList = [];
      if (e) {
        this.qlLessonTemplateHttp(e);
        this.qlDayReleaseLessonsHttp();
      }
    },
    async qlLessonTemplateHttp(lessonId) {
      const response = await qlLessonTemplate({
        lessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.yuwList = response.data;
      }
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    initData() {
      let monday = timeUtils.getFirstDayOfWeek(new Date());
      this.weekDay = [
        { label: "周一", dayTime: formatDate(monday, "yyyy-MM-dd") },
        {
          label: "周二",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -1),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周三",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -2),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周四",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -3),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周五",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -4),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周六",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -5),
            "yyyy-MM-dd"
          ),
        },
        {
          label: "周日",
          dayTime: formatDate(
            timeUtils.getBeforeDayOfDate(monday, -6),
            "yyyy-MM-dd"
          ),
        },
      ];
      if (!this.isVip) {
        this.bookInfo.childName = this.child.childName;
        this.bookInfo.userId = this.child.userId;
        this.bookInfo.childId = this.child.id;
        this.bookInfo.userBuyCardId = this.vipChild ? this.vipChild.id : "";
        this.audio =  this.child.recording
        this.bookInfo = {
          ...this.bookInfo,
          ...this.child,
        };
      } else {
        this.bookInfo.childName = this.vipChild.childName;
        this.bookInfo.userId = this.vipChild.userId;
        this.bookInfo.childId = this.vipChild.childId;
        this.bookInfo.userBuyCardId = this.vipChild.id;
        this.audio =  this.child.recording
      }
      console.log("this.bookInfo", this.bookInfo);
      this.queryParam.lessonTemplateId = this.lessonTemplateId;
    },

    praseLessonName(lesson) {
      let tStr =
        timeUtils.transTimeHM(lesson.classStartTime) +
        "~" +
        timeUtils.transTimeHM(lesson.classEndTime);
      return lesson.name + "(" + tStr + ")";
      return
      if (lesson.lessonTemplateId == enumsUtil.lessonTemplateIdBS()) {
        let tStr =
          timeUtils.transTimeHM(lesson.classStartTime) +
          "~" +
          timeUtils.transTimeHM(lesson.classEndTime);
        let ms = "";
        if (lesson.startMonth < 8) {
          ms = "婴儿";
        } else {
          ms = "幼儿";
        }
        return lesson.name + "/" + ms + "(" + tStr + ")";
      } else {
        let tStr =
          timeUtils.transTimeHM(lesson.classStartTime) +
          "~" +
          timeUtils.transTimeHM(lesson.classEndTime);
        return lesson.name + "(" + tStr + ")";
      }
    },

    qlDayReleaseLessons() {
      let dayTime = "";
      console.log("this.bookInfo", this.bookInfo);
      if (this.isRegular) {
        dayTime = timeUtils.transDayInt(
          this.weekDay[this.selectWeekDay].dayTime
        );
      } else {
        if (commonUtils.isStringNull(this.bookInfo.dayTime)) {
          return;
        }
        dayTime = timeUtils.transDayInt(this.bookInfo.dayTime);
      }
      console.log("aaaaa", dayTime);
      let param = {
        dayTime: dayTime,
        lessonTemplateId: this.queryParam.lessonTemplateId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };

      qlDayReleaseLessons(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }

        this.storeReleaseLessons = data;
      });
    },
    changeDay(val) {
      this.storeReleaseLessons = [];
      this.qlDayReleaseLessons();
    },
    changeLessonTemplate(val) {
      this.qlDayReleaseLessons();
    },
    onClickBookLesson() {
      if (this.isRegular) {
        this.onRegularBook();
      } else {
        this.onTempBook();
      }
    },

    /**
     * 临时
     */
    onTempBook() {
      let self = this;
      self.$refs["refFormData"].validate((valid) => {
        if (valid) {
          let param = {
            userId: self.bookInfo.userId,
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            releaseLessonId: self.bookInfo.storeReleaseLessonId,
            userBuyCardId: self.bookInfo.userBuyCardId,
            userChildrenId: self.bookInfo.childId,
            remark: self.bookInfo.remark,
            ...self.bookInfo,
          };
          const loading = self.myLoading();
          adminBookLesson(param).then((response) => {
            loading.close();
            let data = response.data;
            if (commonUtils.isObjectNull(data)) {
              return;
            }
            messageUtils.successMsg(self, response.message);
            self.$emit("onBookSuccess");
          });
        }
      });
    },

    /**
     *固定预约
     */
    onRegularBook() {
      let param = {
        releaseLessonId: this.bookInfo.storeReleaseLessonId,
        userBuyCardId: this.bookInfo.userBuyCardId,
        childId: this.bookInfo.childId,
        remark: "固定预约",
        regularType: this.regularType,
        noRegularStartDay: this.noRegularStartDay,
        noRegularEndDay: this.noRegularEndDay,
      };
      const loading = this.myLoading();
      regulerBook(param).then((response) => {
        loading.close();
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        messageUtils.successMsg(this, response.message);
        this.$emit("onBookSuccess");
      });
    },

    /**
     * 切换周几
     * @param val
     */
    onChangeWeekDay(val) {
      this.qlDayReleaseLessons();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/components/BookLessonForChildVTwo.vue